import React from 'react';
import {  FaCookie, FaUserShield, FaEnvelope, FaLock } from 'react-icons/fa';
import Header from './common/Header';
import Footer from './common/Footer';

const PrivacyScreen = ({ scrollToSection }) => {
  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <Header scrollToSection={scrollToSection} />
      
      <div className="container mx-auto px-4 py-8 max-w-4xl">
         <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#320A6B] rounded-full mb-4">
            <FaCookie className="text-white text-2xl" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">سياسة الخصوصية</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            نحن في موقع نافس برو نلتزم بحماية خصوصية المستخدمين وبياناتهم الشخصية
          </p>
        </div>

         <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
           <div className="p-6 border-b border-gray-200">
            <div className="flex items-start gap-4 mb-4">
              <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <FaUserShield className="text-blue-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">المعلومات التي نجمعها</h2>
                <p className="text-gray-700 mb-3">
                  عند استخدامك للموقع، قد نقوم بجمع بعض المعلومات مثل:
                </p>
                <ul className="list-disc pr-5 text-gray-700 space-y-2">
                  <li>نتائج اختباراتك ودرجاتك</li>
                  <li>تقدمك في استخدام المنصة</li>
                   <li>معلومات الجهاز والمتصفح المستخدم</li>
                </ul>
              </div>
            </div>
          </div>

           <div className="p-6 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900 mb-4">كيف نستخدم معلوماتك</h2>
            <p className="text-gray-700 mb-4">
              نستخدم هذه المعلومات فقط من أجل:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                    <span className="text-purple-600 font-bold text-sm">١</span>
                  </div>
                  <h3 className="font-bold text-gray-900">تشغيل الموقع</h3>
                </div>
                <p className="text-gray-700 text-sm">
                  تقديم الاختبارات بدقة وضمان عمل المنصة بسلاسة
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                    <span className="text-purple-600 font-bold text-sm">٢</span>
                  </div>
                  <h3 className="font-bold text-gray-900">حفظ التقدم</h3>
                </div>
                <p className="text-gray-700 text-sm">
                  حفظ درجاتك وتقدمك في المنصة لمتابعة أدائك
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                    <span className="text-purple-600 font-bold text-sm">٣</span>
                  </div>
                  <h3 className="font-bold text-gray-900">تحسين التجربة</h3>
                </div>
                <p className="text-gray-700 text-sm">
                  تحسين المحتوى وتجربة المستخدم بناءً على الاستخدام
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                    <span className="text-purple-600 font-bold text-sm">٤</span>
                  </div>
                  <h3 className="font-bold text-gray-900">الدعم الفني</h3>
                </div>
                <p className="text-gray-700 text-sm">
                  تقديم الدعم الفني والمساعدة عند الحاجة
                </p>
              </div>
            </div>
          </div>

           <div className="p-6 border-b border-gray-200">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                <FaLock className="text-red-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">مشاركة المعلومات</h2>
                <p className="text-gray-700 mb-3">
                  نحن نحرص على خصوصية بياناتك ولا نقوم ببيع أو مشاركة معلوماتك الشخصية مع أي جهة خارجية إلا في الحالات التالية:
                </p>
                <ul className="list-disc pr-5 text-gray-700 space-y-2">
                  <li>عند الحاجة القانونية أو استجابة لطلب رسمي من السلطات المختصة</li>
                  <li>لخدمات الاستضافة الموثوقة التي تساعدنا في تشغيل المنصة</li>
                  <li>لحماية حقوقنا أو حقوق المستخدمين الآخرين</li>
                </ul>
              </div>
            </div>
          </div>

           <div className="p-6 border-b border-gray-200">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                <FaCookie className="text-amber-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">ملفات الارتباط (Cookies)</h2>
                <p className="text-gray-700 mb-3">
                  نستخدم ملفات الارتباط لتحسين تجربة المستخدم على المنصة. يمكنك في أي وقت:
                </p>
                <ul className="list-disc pr-5 text-gray-700 space-y-2">
                  <li>طلب حذف بياناتك الشخصية من خلال التواصل معنا</li>
                  <li>إيقاف استخدام ملفات الارتباط من إعدادات المتصفح</li>
                </ul>
                <div className="mt-4 p-4 bg-amber-50 rounded-lg border border-amber-200">
                  <p className="text-amber-800 text-sm">
                    <strong>ملاحظة:</strong> بعض ميزات الموقع قد لا تعمل بشكل صحيح في حال إيقاف ملفات الارتباط.
                  </p>
                </div>
              </div>
            </div>
          </div>

           <div className="p-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <FaEnvelope className="text-green-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">التواصل معنا</h2>
                <p className="text-gray-700 mb-4">
                  إذا كان لديك أي استفسار حول سياسة الخصوصية أو تريد ممارسة حقوقك المتعلقة ببياناتك، يمكنك التواصل معنا عبر:
                </p>
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="flex items-center gap-3">
                    <FaEnvelope className="text-[#320A6B]" />
                    <div>
                      <p className="font-medium text-gray-900">البريد الإلكتروني المخصص للموقع</p>
                      <p className="text-gray-700">info@example.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

         <div className="mt-6 bg-blue-50 rounded-2xl p-6 border border-blue-200">
          <h3 className="font-bold text-blue-800 mb-2">تحديثات سياسة الخصوصية</h3>
          <p className="text-blue-700">
            قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإعلامك بأي تغييرات جوهرية عن طريق نشر الإشعار على موقعنا أو إرسال إشعار مباشر إليك.
          </p>
        </div>
      </div>
      
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
};

export default PrivacyScreen;